import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => {
  return {
    onboadingContainer: {
      flex: 1,
      height: "100%",
      padding: '24px 24px 24px',
      overflowY: 'hidden',
    },
    contentTitle: {
      textAlign: 'center',
      marginBottom: '70px',
      font: `700 19px/25px "Montserrat"`,
      color: theme.custom.colors.primary,
    },
    iconCloseIcon: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '20px',
      cursor: 'pointer'
    },
    contentContainer: {
      // display: 'flex',
      // flexWrap: 'wrap',
      // justifyContent: 'center'
    },
    rowBrikType: {
      display: 'flex',
      '&:not(:nth-child(3))': {
        marginBottom: 32,
      },
      '&>div:not(:last-child)': {
        marginRight: 32,
      },
      '&:nth-child(3)': {
        borderTop: `1px solid ${theme.custom.colors.borderGrey}`,
        paddingTop: 32,
      },
    },
    contentItem: {
      display: 'flex',
      flexDirection: "row",
      alignItems: 'center',
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      borderRadius: '6px',
      padding: '12px 12px',
      cursor: 'pointer',
      border: '1px solid transparent',
      '&:hover': {
        border: `1px solid ${theme.custom.colors.purp}`
      }
    },
    bgImage: {
      borderRadius: '50%',
      width: '80px',
      height: '80px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    textItem: {
      flexDirection: 'column',
      justifyContent: 'center',
      maxWidth: '375px',
    }, 
    textName: {
      display: 'flex',
      font: `700 14px/18px "Montserrat"`,
      color: theme.custom.colors.primary,
    }, 
    textDescription: {
      display: 'flex',
      font: `400 14px/18px "Montserrat"`,
      color: theme.custom.colors.midBlack,
    },
    lineBreak: {
      height: 1,
      margin: '0 40px',
      width: '100%',
      background: theme.custom.colors.borderGrey,
    },
    tooltip: {
      background: '#000',
      padding: `10px !important`,
      font: 'normal normal 400 13px/24px Public-Sans !important',
      borderRadius: 20,
      maxWidth: 500,
    },
    popupTooltip: {
      color: '#111',
    },
    onDemandContainer: {
      flex: 1,
    }
  };
});

export default useStyles;
